import loadable from '@loadable/component';

const PerfumesLoadable = loadable(() => import(/* webpackChunkName: 'perfumes' */ './Perfumes'));

const Perfumes = () => <PerfumesLoadable />;

export default Perfumes;
